import type { ReactNode } from "react";

/**
 * Inline SVG glyphs for top-nav apps. Filled/duotone, currentColor only —
 * same approach as IMS appIcons so light/dark inherit cleanly.
 */
const ICONS: Record<string, ReactNode> = {
  dashboard: (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="2.5" y="2.5" width="9" height="9" rx="2" fill="currentColor" />
      <rect x="12.5" y="2.5" width="9" height="5.2" rx="2" fill="currentColor" opacity="0.6" />
      <rect x="12.5" y="9.7" width="9" height="11.8" rx="2" fill="currentColor" opacity="0.35" />
      <rect x="2.5" y="13.5" width="9" height="8" rx="2" fill="currentColor" opacity="0.6" />
    </svg>
  ),
  crm: (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="8.2" cy="8" r="3.2" fill="currentColor" opacity="0.35" />
      <circle cx="16.2" cy="8.8" r="2.6" fill="currentColor" opacity="0.55" />
      <path
        d="M3.5 19.5c.6-3.2 2.9-5 5.7-5s5.1 1.8 5.7 5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M13.2 14.8c1.5-.7 3.2-.8 4.8.1 1.8 1 2.8 2.7 3 4.6"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        fill="none"
        opacity="0.7"
      />
    </svg>
  ),
  timesheet: (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="9" fill="currentColor" opacity="0.18" />
      <circle cx="12" cy="12" r="7.2" stroke="currentColor" strokeWidth="1.8" />
      <path d="M12 7.2v5.1l3.4 2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="12" cy="12" r="1.15" fill="currentColor" />
    </svg>
  ),
  expense: (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M7.2 4.4h7.1c.4 0 .8.2 1 .5l2.5 3.4c.2.3.3.6.3 1v8.8c0 .9-.7 1.6-1.6 1.6H7.2c-.9 0-1.6-.7-1.6-1.6V6c0-.9.7-1.6 1.6-1.6Z"
        fill="currentColor"
        opacity="0.22"
      />
      <path
        d="M7.2 4.4h7.1c.4 0 .8.2 1 .5l2.5 3.4c.2.3.3.6.3 1v8.8c0 .9-.7 1.6-1.6 1.6H7.2c-.9 0-1.6-.7-1.6-1.6V6c0-.9.7-1.6 1.6-1.6Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path d="M15.1 4.8v3.2h3.1" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M8.4 12.2h7.2M8.4 15.2h4.6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="M6.2 19.4c1.6-1.2 2.8-1.3 4.1-.2 1.2 1 2.5 1.1 3.8.2"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        opacity="0.85"
      />
    </svg>
  ),
};

export function getAppIcon(code: string): ReactNode {
  return (
    ICONS[code] ?? (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" fill="currentColor" opacity="0.35" />
        <circle cx="12" cy="12" r="3" fill="currentColor" />
      </svg>
    )
  );
}
